/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM, T } from "@adapptio/lib-components";

import "./ReferenceGuideRightbar.scss";
import { TReferenceData } from "../../ReferenceGuideTypes";

export interface IRightbarChildProps {
	data: TReferenceData[];
	parentIdx?: number;
}

const ChildNav: React.FC<IRightbarChildProps> = ({ data, parentIdx = -1 }) => {
	const smoothScroll = (e, idx) => {
		e.preventDefault();

		const section = document.getElementById(parentIdx >= 0 ? `${parentIdx}${idx}` : idx);
		section && section.scrollIntoView({ behavior: "smooth", block: "start" });
	};

	return (
		<ul>
			{data.map((item, idx) => {
				if (item) {
					return (
						<li key={idx}>
							<a href="/" onClick={(e) => smoothScroll(e, idx)}>
								<T domain="editor" term={item.label} />
							</a>
							{!!item.child?.length && <ChildNav data={item.child} parentIdx={idx} />}
						</li>
					);
				}
			})}
		</ul>
	);
};

export interface IReferenceGuideRightbarProps {
	className?: string;
	nav: TReferenceData;
}

export const ReferenceGuideRightbar: React.FC<IReferenceGuideRightbarProps> = ({ className, nav }) => {
	const baseClass = BEM("edt-reference-rightbar");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("sub-nav").toClassName()}>
				{!!nav.child?.length && <ChildNav data={nav.child} />}
			</div>
		</div>
	);
};
